<!-- [1段目] -->
<div class="p-input-list-area01">
  <div class="p-input-list-area01__item">
    <div class="p-input-list-area01__block">
      <div class="p-input-list-area01__block-item">
        <asw-airport-round id="roundtrip-airport-round" (switchEvent)="switch($event)">
          <asw-airport
            origin
            label="origin"
            [airportListParts]="airportListPartsFrom"
            [(selectedAirport)]="selectedOriginAirport"
            (changeEvent)="getOutputOriginAirport($event)"
            [airportFormControl]="this.originAirportControl"
            id="roundtrip-airport-from"
            #originAirportComponent
          ></asw-airport>
          <asw-airport
            destination
            [airportListParts]="airportListPartsTo"
            [(selectedAirport)]="selectedDestinationAirport"
            (changeEvent)="getOutputDestinationAirport($event)"
            [airportFormControl]="this.destinationAirportControl"
            id="roundtrip-airport-to"
            #destinationAirportComponent
          ></asw-airport>
        </asw-airport-round>
      </div>
    </div>
  </div>

  <div class="p-input-list-area01__item">
    <div class="p-input-list-area01__block p-input-list-area01__block--half">
      <div class="p-input-list-area01__block-item">
        <div class="p-input-list-area01__block-item-box">
          <asw-date-selector
            #departureAndReturnDateComponent
            [dateSelectorParts]="dateSelectorParts"
            (changeDate)="getOutputDepartureAndReturnDate($event)"
            id="roundtrip-date-selector-1"
            [dateForm]="this.departureAndReturnDateFormGroup"
          >
          </asw-date-selector>
        </div>

        <div class="p-input-list-area01__block-item-box">
          <div class="c-form-element-checkbox">
            <div class="c-form-element-checkbox__wrap">
              <asw-checkbox
                label="{{ 'label.searchFlightFlexibleDate' | staticMsg }}"
                [formControl]="formControlCompareFaresNearbyDates"
                (change$)="getOutputCompareFaresNearbyDate($event)"
                [disabled]="isJapanOnlyFlag"
                id="roundtrip-checkbox-1"
              ></asw-checkbox>
            </div>
          </div>
        </div>
      </div>

      <div class="p-input-list-area01__block-item">
        <asw-passenger-selector
          [passengersCount]="this.passengersCount"
          [passengersErrorMsg]="information.passengersErrorMsg"
          [isEnabled]="this.isEnabled"
          [isInfantCountShow]="
            !this.isJapanOnlyFlag || this.posCountryCode === 'JP' || dcsMigrationDateStatus !== 'Before'
          "
          [isChild3To11]="this.isJapanOnlyFlag && this.posCountryCode !== 'JP' && dcsMigrationDateStatus === 'Before'"
          [isInfant0To1]="!oldDomesticAswSearchFlag"
          [dcsMigrationDateStatus]="dcsMigrationDateStatus"
          (apply$)="getOutputPassengerSelect($event)"
        ></asw-passenger-selector>
      </div>
    </div>
  </div>
</div>
<!-- //[1段目] -->

<!-- [option] -->
<div class="p-input-list-area02">
  <!-- [option 開閉ボタン] -->
  <div class="p-input-list-area02__head">
    <button
      #searchOptionButton
      type="button"
      id="roundtrip-button-1"
      class="c-option-btn01 js-drawer-options-btn"
      [ngClass]="{ ' is-open': isOpenSearchOption }"
      aria-controls="drawer-options"
      [attr.aria-expanded]="isOpenSearchOption"
      (click)="clickOptionOpen()"
      [innerHTML]="'label.transferconditionsOptionMenu.open' | staticMsg"
    ></button>
  </div>
  <!-- //[option 開閉ボタン] -->

  <div
    #drawerOptions
    id="drawer-options"
    class="p-input-list-area02__body js-drawer-options-body"
    [ngClass]="{ ' is-open': isOpenSearchOption }"
    aria-labelledby="roundtrip-button-1"
  >
    <div class="p-input-list-area02__item">
      <div class="p-input-list-area02__block p-input-list-area02__block--half">
        <!-- [option 左側] -->
        <div class="p-input-list-area02__block-item">
          <div class="p-input-list-area02__block-item-box">
            <h3 class="p-input-list-area02__block-item-title" [innerHTML]="'label.outwardPath' | staticMsg"></h3>
          </div>
          <div class="p-input-list-area02__block-item-box">
            <h4 class="p-input-list-area02__block-item-lv2title" [innerHTML]="'labal.departureTime' | staticMsg"></h4>
            <asw-range-slider
              type="time"
              ariaLabel="labal.departureTime"
              handlePoint="two"
              [valueMin]="this.TIME_WINDOW_MIN"
              [valueMax]="this.TIME_WINDOW_MAX"
              [stepGrid]="this.TIME_WINDOW_STEP"
              [disabled]="oldDomesticAswSearchFlag"
              unitFront=""
              unitBack=""
              [formControl]="this.formControlDepartureTimeWindow"
            ></asw-range-slider>
          </div>
          <div class="p-input-list-area02__block-item-box">
            <div class="c-form-element-input c-form-element-input--has-function">
              <asw-airport
                #transitDepartComponent
                label="Transit Airport"
                [airportListParts]="airportListPartsTransit"
                [(selectedAirport)]="selectedTransitDepartAirport"
                (changeEvent)="getOutputTransitDepartAirport($event)"
                [airportFormControl]="this.originTransitAirportControl"
                [oldAswTerm]="oldDomesticAswSearchFlag"
                id="roundtrip-airport-from-connection"
              ></asw-airport>
            </div>
          </div>
          <div class="p-input-list-area02__block-item-box">
            <h4
              class="p-input-list-area02__block-item-lv2title"
              [innerHTML]="'label.transferconditionTime' | staticMsg"
            ></h4>
            <asw-range-slider
              type="interval"
              ariaLabel="label.transferconditionTime"
              handlePoint="one"
              [valueMin]="this.CONNECTION_TIME_MIN"
              [valueMax]="this.CONNECTION_TIME_MAX"
              [stepGrid]="this.CONNECTION_TIME_STEP"
              [disabled]="oldDomesticAswSearchFlag"
              unitFront=""
              unitBack=""
              [formControl]="this.formControlDepartureConnectionTime"
            ></asw-range-slider>
          </div>
        </div>
        <!-- //[option 左側] -->

        <!-- [option 右側] -->
        <div class="p-input-list-area02__block-item">
          <div class="p-input-list-area02__block-item-box">
            <h3 class="p-input-list-area02__block-item-title" [innerHTML]="'label.returnPath' | staticMsg"></h3>
          </div>
          <div class="p-input-list-area02__block-item-box">
            <h4 class="p-input-list-area02__block-item-lv2title" [innerHTML]="'labal.departureTime' | staticMsg"></h4>
            <asw-range-slider
              type="time"
              handlePoint="two"
              ariaLabel="labal.departureTime"
              [valueMin]="this.TIME_WINDOW_MIN"
              [valueMax]="this.TIME_WINDOW_MAX"
              [stepGrid]="this.TIME_WINDOW_STEP"
              [disabled]="oldDomesticAswSearchFlag"
              unitFront=""
              unitBack=""
              [formControl]="this.formControlReturnTimeWindow"
            ></asw-range-slider>
          </div>
          <div class="p-input-list-area02__block-item-box">
            <div class="c-form-element-input c-form-element-input--has-function">
              <asw-airport
                #transitReturnComponent
                label="Transit Airport"
                [airportListParts]="airportListPartsTransit"
                [(selectedAirport)]="selectedTransitReturnAirport"
                (changeEvent)="getOutputTransitReturnAirport($event)"
                [airportFormControl]="this.destinationTransitAirportControl"
                [oldAswTerm]="oldDomesticAswSearchFlag"
                id="roundtrip-airport-to-connection"
              ></asw-airport>
            </div>
          </div>
          <div class="p-input-list-area02__block-item-box">
            <h4
              class="p-input-list-area02__block-item-lv2title"
              [innerHTML]="'label.transferconditionTime' | staticMsg"
            ></h4>
            <asw-range-slider
              type="interval"
              ariaLabel="label.transferconditionTime"
              handlePoint="one"
              [valueMin]="this.CONNECTION_TIME_MIN"
              [valueMax]="this.CONNECTION_TIME_MAX"
              [stepGrid]="this.CONNECTION_TIME_STEP"
              [disabled]="oldDomesticAswSearchFlag"
              unitFront=""
              unitBack=""
              [formControl]="this.formControlReturnConnectionTime"
            ></asw-range-slider>
          </div>
        </div>
        <!-- //[option 右側] -->
      </div>
    </div>

    <div class="p-input-list-area02__item">
      <div class="p-input-list-area02__block-link">
        <a
          href="#"
          id="roundtrip-link-1"
          class="c-text-link-arrow01"
          (click)="clickStopOverLink($event)"
          [innerHTML]="'label.stopover' | staticMsg"
        ></a>
      </div>
    </div>
  </div>
</div>
<!-- //[option] -->

<!-- [2段目] -->
<div class="p-input-list-area01">
  <div class="p-input-list-area01__item">
    <div class="p-input-list-area01__block">
      <div class="p-input-list-area01__block-item">
        <!-- ミックスキャビン -->
        <asw-toggle
          id="roundtrip-toggle"
          [isEnable]="!this.isJapanOnlyFlag || this.dcsMigrationDateStatus !== 'Before'"
          [checked]="this.formControlMixedCabinSwitch.value!"
          text="{{ 'label.differentClass' | staticMsg }}"
          altMessage="{{ 'label.differentClass' | staticMsg }}"
          (changeEvent)="getOutputMixedCabinSwitch()"
        ></asw-toggle>
      </div>
    </div>
  </div>
  <div class="p-input-list-area01__item">
    <div class="p-input-list-area01__block p-input-list-area01__block--half">
      <div class="p-input-list-area01__block-item">
        <!-- キャビンクラス指定プルダウン -->
        <div class="c-form-element-select is-selected">
          <div class="c-form-element-select__wrap">
            <label for="roundtrip-select-1" class="c-form-element-select__label"
              ><span
                class="c-form-element-select__label-text"
                [innerHTML]="
                  (this.formControlMixedCabinSwitch.value ? 'label.DepartureClass' : 'label.selectClass') | staticMsg
                "
              ></span
            ></label>
            <select
              class="c-form-element-select__select"
              id="roundtrip-select-1"
              name="roundtrip-select-1"
              aria-invalid="false"
              (change)="getOutputCabinClass($event)"
            >
              <option
                *ngFor="let option of this.cabinClassOptions"
                value="{{ option.value }}"
                [selected]="option.value === selectedCabinClass"
              >
                {{ option.textContent }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <div class="p-input-list-area01__block-item">
        <!-- ミックスキャビン有効の場合、復路キャビンクラス指定プルダウン -->
        <ng-container *ngIf="this.formControlMixedCabinSwitch.value">
          <div class="c-form-element-select is-selected">
            <div class="c-form-element-select__wrap">
              <label for="roundtrip-select-2" class="c-form-element-select__label"
                ><span class="c-form-element-select__label-text" [innerHTML]="'label.ReturnClass' | staticMsg"></span
              ></label>
              <select
                class="c-form-element-select__select"
                id="roundtrip-select-2"
                name="roundtrip-select-2"
                aria-invalid="false"
                (change)="getOutputReturnCabinClass($event)"
              >
                <option
                  *ngFor="let option of this.cabinClassOptions"
                  value="{{ option.value }}"
                  [selected]="option.value === selectedReturnCabinClass"
                >
                  {{ option.textContent }}
                </option>
              </select>
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="!this.formControlMixedCabinSwitch.value && this.isFareTypeShow">
          <asw-fare-type-selector
            [selected]="this.selectedFareOptionType"
            [selectedCabinClass]="this.selectedCabinClass"
            [isEnabled]="this.isEnabled"
            [isJapanOnlyFlag]="this.isJapanOnlyFlag"
            (apply$)="getOutputFareOptionType($event)"
          >
          </asw-fare-type-selector>
        </ng-container>
      </div>
    </div>
  </div>
</div>
<!-- //[2段目] -->

<!-- [3段目] -->
<div class="p-input-list-area01">
  <div class="p-input-list-area01__item">
    <div class="p-input-list-area01__block p-input-list-area01__block--half">
      <div class="p-input-list-area01__block-item">
        <ng-container *ngIf="this.isOnlyPromotionCodeAvailable">
          <asw-input
            label="{{ 'label.promotionCode1' | staticMsg }}"
            placeholder="{{ 'placeholder.promotionCode' | staticMsg }}"
            type="text"
            [formControl]="formControlPromotionCode"
            (change$)="getOutputPromotionCode($event)"
            id="roundtrip-input-1"
            [disabled]="oldDomesticAswSearchFlag"
            maxlength="15"
          ></asw-input>
        </ng-container>
      </div>
    </div>
  </div>
</div>
<!-- //[3段目] -->
